<template>
	<div id="map-wrap">
		<div id="map"></div>
		
		<div class="sidebar-wrap" :class="{'open': showSidebar, 'no-location-set': !hasLocation}">
			<div class="list-wrap">
				<div class="title-address-wrap" style="margin-bottom: var(--wp--preset--spacing--70);">
          <div class="title-wrap">
            <h3 v-html="servicefinder.labels.heading" class="has-h-2-font-size" style="text-transform: uppercase;margin-top:0; margin-bottom: var(--wp--preset--spacing--30); max-width: 500px"></h3>
            <p v-html="servicefinder.labels.subheading" style="margin-top: var(--wp--preset--spacing--60); margin-bottom: 0;"></p>
          </div>
					
					<div class="address-input-wrap" style="margin-top: auto">
            <div class="address-radius-wrap">
              <input type="text" id="address" placeholder="Enter your address" v-model="maps.address">
              <div class="radius-filter">
                <select id="radius" v-model="selectedRadius" @change="onRadiusChange">
                  <option v-for="radius in radiusOptions" :key="radius" :value="radius">
                    {{ radius }} km
                  </option>
                </select>
              </div>
            </div>
          </div>
          
				</div>
        

				<div class="collapsible-wrap">
					<div class="results" :class="{'loading' : results.loading || gettingLocation}">
						<div class="result" v-for="post in results.posts" :class="{'hovered': post.hovered}" style="border-left: 1px solid black; padding-left: 1.5rem;margin-top: 0">
							<p class="has-h-4-font-size" style="margin-bottom: 0;margin-top: 0; font-weight: 700" v-html="post.title"></p>
							<p class="has-small-font-size" style="margin-top: var(--wp--preset--spacing--10); margin-bottom: 0;" v-html="post.meta.street_address"></p>
              <p style="margin-bottom: 0;"><a :href="formatURL(post.meta.site_url)" class="has-small-font-size" style="margin-bottom: 0; text-decoration: underline;"><strong v-html="formatURL(post.meta.site_url)"></strong></a></p>
              <p style="margin-top: 0;"><a
                  v-if="post.meta.secondary_site_url"
                  :href="formatURL(post.meta.secondary_site_url)"
                  class="has-small-font-size"
                  style="margin-bottom: 0; text-decoration: underline;"
                >
                  <strong v-html="formatURL(post.meta.secondary_site_url)"></strong>
                </a></p>
              <p class="has-small-font-size" v-if="post.distance !== null && post.distance !== undefined">
                {{ post.distance }} km away
              </p>
						</div>

						<div class="empty result" v-if="loaded && !results.posts.length">
							<p v-if="!results.loading && hasLocation" class="has-small-font-size" v-html="servicefinder.labels.noResults"></p>
						</div>
					</div>

					<div class="summary-pagination has-small-font-size" v-if="results.posts.length">
	          <div class="pagination">
              <a v-for="page in results.maxPage"
                 :key="page"
                 @click="loadPage(page)"
                 :class="{'current-page': page === results.page}"
                 :data-page="page">
                {{ page }}
              </a>
            </div>
          </div>
				</div>

				
			</div>
		</div>
		<div id="search-here" v-if="showSearchHere" @click="searchHere">
			<span class="button" v-html="servicefinder.labels.searchHere"></span>
		</div>
	</div>
</template>

<script>

const mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#9f9f9f"
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#212121"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "elementType": "labels",
    "stylers": [
      {
        "lightness": -50
      },
      {
        "visibility": "on"
      },
      {
        "weight": 2
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#bdbdbd"
      },
      {
        "weight": 2
      }
    ]
  },
  {
    "featureType": "administrative.province",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#929292"
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1b1b1b"
      }
    ]
  },
  {
    "featureType": "road",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#2c2c2c"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#8a8a8a"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#373737"
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#3c3c3c"
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#4e4e4e"
      },
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#929292"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#3d3d3d"
      }
    ]
  }
];

	export default {
		data() {
			return {
				namespace: '/wp-json/oacp/v1/services',
				results: {
                    loading: false,
                    posts: [],
                    total: 0,
                    page: 1,
                    maxPage: 0
                },
                query: {
                    paged: 1,
                    lat: '',
                    lng: '',
                    per_page: 9,
                    radius: 100,
                },
                loaded: false,
                showSidebar: true,
                mobileShowList: false,
                showSearchHere: false,
				maps: {
					map: null,
					markers: [],
					loaded: false,
					location: null,
					address: ''
				},
				allPosts: [] // Store all posts for all markers
			}
		},

		computed: {
			mobileListToggleIcon() {
				return this.mobileShowList ? 'map-icon' : 'list-icon';
			},

			mobileListToggleLabel() {
				return this.mobileShowList ? this.servicefinder.labels.showMap : this.servicefinder.labels.showList;
			},

			hasLocation() {
				return this.loaded && this.query.lat && this.query.lng;
			},

			getStartingResult() {
				return (this.results.page - 1) * this.query.per_page + 1;
			},

			getEndResult() {
				return (this.results.page - 1) * this.query.per_page + this.results.posts.length;
			}
		},

		watch: {
			'query.paged'(val) {
				this.getservices();
			},

			'query.lng'(val) {
				if (val) {
					this.updateMapCenter();
				}
				this.filterservices();
			},

			'results.posts'(val) {
				this.updateMap();
				this.createMarkers();
			},

			'maps.loaded'(val) {
				if (val && this.query.lat && this.query.lng && this.query.radius) {
					this.initMap();
					this.getservices();
				} else if (val && !this.servicefinder.location.lat) {
					this.findUserLocation();
				}
			}
		},

		created() {
			//Link to servicefinder data
			this.servicefinder = window.servicefinder;
      this.query.radius = this.selectedRadius;
		},

    mounted() {

      // if (typeof MarkerClusterer === 'function') {
      //   console.log('✅ Clusterer is ready');

        // this.clusterer = new MarkerClusterer({
        //   map: this.maps.map,
        //   markers: this.maps.allMarkers
        // });
      // } else {
      //   console.warn('❌ Clusterer not available at mount');
      // }
      this.initGoogle().then(() => {
        this.maps.loaded = true;
        this.query.radius = this.selectedRadius;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
          pos => {
            this.query.lat = pos.coords.latitude;
            this.query.lng = pos.coords.longitude;
            this.reverseGeocode(this.query.lat, this.query.lng).then(() => {
              this.initMapAndLoad();
            });
          },
          err => {
            console.error('❌ Geolocation error:', err);
            this.setDefaultLocation();
          },
          { timeout: 10000 } // optional: give up after 10s
        );
        } else {
          console.warn("Geolocation unsupported, using default location");
          this.setDefaultLocation();
        }
      });
    },

		methods: {
      initMap() {
        const mapElement = document.getElementById("map");
        if (!mapElement) return;

        // Default location (example: Toronto)
        const defaultLat = 43.6532;
        const defaultLng = -79.3832;

        this.maps.map = new google.maps.Map(mapElement, {
          center: { lat: defaultLat, lng: defaultLng },
          zoom: 10n,
          styles: mapStyles
        });
      },
      async reverseGeocode(lat, lng) {
        if (!window.google || !google.maps || !google.maps.Geocoder) return;
        const geocoder = new google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
        return new Promise((resolve) => {
          geocoder.geocode({ location: latlng }, (results, status) => {
            let resultAddress = '';
            if (status === 'OK' && results[0]) {
              // Try to extract city and province from address_components
              const components = results[0].address_components || [];
              let city = '';
              let province = '';
              // Find city
              for (let comp of components) {
                if (comp.types.includes('locality')) {
                  city = comp.short_name;
                  break;
                }
              }
              // Find province (administrative_area_level_1)
              for (let comp of components) {
                if (comp.types.includes('administrative_area_level_1')) {
                  province = comp.short_name;
                  break;
                }
              }
              // Fallbacks if locality not found (sometimes 'sublocality' or 'administrative_area_level_2')
              if (!city) {
                for (let comp of components) {
                  if (comp.types.includes('sublocality')) {
                    city = comp.short_name;
                    break;
                  }
                }
              }
              if (!city) {
                for (let comp of components) {
                  if (comp.types.includes('administrative_area_level_2')) {
                    city = comp.short_name;
                    break;
                  }
                }
              }
              // Set address as "City, Province" if both present, else fallback to formatted_address
              if (city && province) {
                this.maps.address = `${city}, ${province}`;
                resultAddress = `${city}, ${province}`;
              } else {
                this.maps.address = results[0].formatted_address;
                resultAddress = results[0].formatted_address;
              }
            }
            resolve(resultAddress);
          });
        });
      },
      getservices() {
        const base = this.namespace;
        const { lat, lng, radius, paged } = this.query;

        const filteredURL = `${base}/search?paged=${paged}&lat=${lat}&lng=${lng}&radius=${radius}`;
        const allURL = `${base}/all`;

        this.results.loading = true;

        Promise.all([
          this.getData(filteredURL),
          this.getData(allURL)
        ])
          .then(([filtered, all]) => {
            // Filtered results
            this.results.posts = filtered.posts || [];
            this.results.page = filtered.page;
            this.results.maxPage = filtered.maxPage;
            this.results.total = filtered.total;

            // All results
            this.allPosts = all.posts || [];

            this.clearMarkers();
            this.updateMap(); 
          })
          .catch(err => {
            console.error('Error fetching services:', err);
          })
          .finally(() => {
            this.results.loading = false;
            this.loaded = true;
          });
      },

     createMarkers() {
        this.clearMarkers();

        const markerPosts = this.allPosts && this.allPosts.length ? this.allPosts : this.results.posts;

        this.maps.markers = markerPosts.map(post => {
          const lat = parseFloat(post.meta.lat);
          const lng = parseFloat(post.meta.lng);
          
          if (!lat || !lng) return null;

          const marker = new google.maps.Marker({
            position: { lat, lng },
            map: this.maps.map,
            title: post.title && post.title.rendered ? post.title.rendered : post.title,
            icon: {
              path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z M12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z",
              fillColor: "#FFD200",
              fillOpacity: 1,
              strokeColor: "#FFD200",
              strokeWeight: 0.5,
              scale: 1.5,
              anchor: new google.maps.Point(12, 24)
            }
          });

          marker.refersTo = post;
          marker.addListener('click', () => {
            this.showInfoWindow(marker);
          });

          return marker;
        }).filter(Boolean);

        // ✅ Create the clusterer with custom SVG renderer
        if (window.MarkerClusterer) {
          if (this.maps.clusterer) {
            this.maps.clusterer.clearMarkers();
          }
          const svg = `
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                    <circle cx="120" cy="120" r="70" fill="#FFFFFF" stroke="#FFD200" stroke-width="5"/>
                  </svg>
                `;
          // encode SVG as URI component (not base64)
          const svgUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svg.trim())}`;
          const clusterStyles = [{
            url: svgUrl, 
            height: 56,
            width: 56,
            textColor: "#000000",
            textSize: 12,
            fontWeight: "900",
            fontFamily: "GreycliffCF, Helvetica, Arial, Sans-Serif"
          }];
          this.maps.clusterer = new MarkerClusterer(this.maps.map, this.maps.markers, {
            styles: clusterStyles,
          });
        } else {
          console.warn('MarkerClusterer is not loaded.');
        }
      },

      clearMarkers() {
         if (this.maps.markers) {
            this.maps.markers.forEach(marker => marker.setMap(null));
            this.maps.markers = [];
          }

          if (this.maps.allMarkers) {
            this.maps.allMarkers.forEach(marker => marker.setMap(null));
            this.maps.allMarkers = [];
          }
      },
      formatURL(url) {
        if (!url) return '#';
        return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
      },
      onRadiusChange() {
        this.query.radius = this.selectedRadius;
        this.filterservices();
      },

      async geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
              const location = results[0].geometry.location;
              resolve({
                lat: location.lat(),
                lng: location.lng()
              });
            } else {
              reject(`Geocode failed: ${status}`);
            }
          });
        });
      },

      async filterservices() {
        this.query.paged = 1;
        this.query.radius = this.selectedRadius;

        const address = this.maps.address;

        try {
          const coords = await this.geocodeAddress(address);
          this.query.lat = coords.lat;
          this.query.lng = coords.lng;

          const mapElement = document.getElementById("map");
          if (!mapElement) {
            console.warn("Map element not found");
            return;
          }

          if (!this.maps.map) {
            this.maps.map = new google.maps.Map(mapElement, {
              center: { lat: coords.lat, lng: coords.lng },
              zoom10,
              styles: mapStyles
            });
          } else {
            this.maps.map.setCenter({ lat: coords.lat, lng: coords.lng });
            this.maps.map.setZoom(10);
          }

          this.getservices();
        } catch (err) {
          console.error(err);
        }
      },
      
			clearLocationAndResults() {
				//Stop reload
				this.results.loading = true;

				//Clear maps
				this.maps.address = '';

				//Clear query
				this.query = {
					lat: '',
					lng: '',
					paged: 1,
					types: [],
					per_page: 9
				};

				//Clear results
				this.results = {
                    loading: false,
                    posts: [],
                    total: 0,
                    page: 1,
                    maxPage: 0
                };

                //Clear map
                this.clearMarkers();

                //Reset sidebar states
                this.showSidebar = true;
                this.mobileShowList = false;

                //Allow loading again
                this.results.loading = false;
			},

			toggleSidebar() {
				this.showSidebar = !this.showSidebar;
			},

			toggleMobileList() {
				this.mobileShowList = !this.mobileShowList;
			},

      findUserLocation() {
        if (!navigator.geolocation) {
          console.warn("Geolocation is not supported by this browser.");
          this.setDefaultLocation();
          return;
        }

        navigator.geolocation.getCurrentPosition(
          async position => {
            this.query.lat = position.coords.latitude;
            this.query.lng = position.coords.longitude;
            
            await this.reverseGeocode(this.query.lat, this.query.lng);
            this.initMapAndLoad();
          },
          error => {
            console.warn("Geolocation failed, using default location");
            this.setDefaultLocation();
          }
        );
      },

      setDefaultLocation() {
        this.query.lat = 43.6532;  // Toronto lat
        this.query.lng = -79.3832; // Toronto lng
        this.reverseGeocode(this.query.lat, this.query.lng);
        this.initMapAndLoad();
      },

      initMapAndLoad() {
        const mapElement = document.getElementById("map");
        if (!mapElement) return;

        this.maps.map = new google.maps.Map(mapElement, {
          center: { lat: this.query.lat, lng: this.query.lng },
          zoom: 10,
          styles: mapStyles
        });

        this.getservices();
      }
		},
	}
</script>

      